import React from "react";
import DotWaveBackground from "../components/Background/DotWaveBackground";
import {
  HeroSection,
  PainPointsSection,
  ProductShowcase,
  AudiencePaths,
  AppSection,
  ClosingCta,
} from "../components/landing";

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen w-full flex flex-col items-center overflow-hidden relative isolate bg-black">
      <DotWaveBackground />
      {/* Spacer for fixed header */}
      <div className="h-14" />

      {/* Hero Section - Split screen layout */}
      <HeroSection />

      <PainPointsSection />
      <ProductShowcase />
      <AudiencePaths />
      <AppSection />
      <ClosingCta />
    </div>
  );
};

export default HomePage;
